import { createMemo } from "solid-js"
import isEntityWater from "../../lib/core/entity/isEntityWater"
import type { WaterEntityUnion } from "../../lib/core/entity/WaterEntityUnion.type"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { useSharedTerrainLayer1EntsListMemo } from "./useSharedTerrainLayer1EntsListMemo"

// return all layer 1 terrain water ents
export const useSharedWaterEntsListMemo = createSharedCachedFactory((engine) => {
  const getTerrainLayer1EntsList = useSharedTerrainLayer1EntsListMemo(engine)

  const getWaterEntsList = createMemo<Array<WaterEntityUnion>>(() => {
    const terrainEnts = getTerrainLayer1EntsList()
    return terrainEnts.filter(isEntityWater)
  }, [], {
    equals: isIdListSame,
  })

  // createEffect(() => {
  //   console.log('WaterEntsList', getWaterEntsList())
  // })

  return getWaterEntsList
})
